const OfferCard = ({ offer, isModal, openSubscriptionModal, openViewMoreModal, index, offerIndex, handleSelect, offerCode }) => {
    return (
        <div className={`${!isModal ? "border border-1 border-gray rounded-1 p-3 h-100 d-flex flex-column justify-content-between" : ''}`}>
            {!isModal ? <div className="d-flex justify-content-between align-items-center py-2">
                <h3 className="fs-5 text-black fw-bold mb-0 truncate-single-line" title={offer.offerName}>
                    {offer.offerName}
                </h3>
                {offer.offerCode != offerCode ?
                    <button className="rv-subscription-btn rounded-1 border-0 px-3" onClick={() => {
                        handleSelect(offer, offerIndex, index)
                        openSubscriptionModal(index, offerIndex)
                    }
                    }>
                        Select
                    </button> : <p className="rv-subscription-currentPlan-Label rounded-1 text-center px-2 mb-0">Current Plan</p>}

            </div> : null}
            <div className="py-3">
                <span className="fs-5  text-wrap  w-100 text-break">
                    <span className="rv-offer-code p-2 d-inline-block rounded-2 fw-bold">
                        {offer.offerCode.toUpperCase()}
                    </span>

                </span>
            </div>
            <div className="py-3">
                <div className="d-flex align-items-center">
                    <span
                        className="rv-primary-background-color p-1 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                    >
                        <i class="ri-calendar-2-line rv-text-primary-color"></i>
                    </span>
                    <div className="px-2">
                        <h4 className="fs-14 mb-0 rv-text-label-color">
                            Validity
                        </h4>
                        <h4 class="mb-0 fs-14 fw-semibold text-black">
                            {offer.termValidity}
                        </h4>
                    </div>
                </div>
            </div>
            <div className="py-3">
                <div className="d-flex align-items-center">
                    <span
                        className="rv-grants-icon-bg p-1 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                    >
                        <i class="ri-gift-line rv-grants-icon-color"></i>
                    </span>
                    <div className="px-2">
                        <h4 className="fs-14 mb-0 rv-text-label-color">
                            Grants
                        </h4>
                        {!isModal && (offer?.GrantCard?.length ? (
                            <h4 class="mb-0">
                                {" "}
                                <span className="fw-semibold fs-14 text-black">
                                    {offer?.GrantCard[0].grantAmount}{" "}
                                    {offer?.GrantCard[0].uom}{" "}
                                </span>
                                {offer?.GrantCard?.length - 1 > 0 ? (
                                    <span
                                        className="rv-text-label-color fs-12 ms-2"
                                    >
                                        {" "}
                                        + {offer?.GrantCard?.length - 1} more
                                    </span>
                                ) : (
                                    ""
                                )}
                            </h4>
                        ) : (
                            <h4 class="mb-0">
                                <span className="fw-semibold fs-14 text-black">
                                    No grants available
                                </span>
                            </h4>
                        ))}

                    </div>
                </div>
                {isModal && <div className="ms-32">
                    {offer?.GrantCard?.length ? (offer?.GrantCard?.map((grant, index) => (
                        <h4 key={index} className="text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center">
                            <span className="fs-14 fw-semibold">
                                {grant?.grantAmount} {grant?.uom}
                            </span>{" "}
                            <span className="fs-12">{grant?.oneTimeorRecurring}</span>
                        </h4>
                    ))) : <h4 class="mb-0">
                        <span className="fs-14 text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center">
                            No grants available
                        </span>
                    </h4>}

                </div>}
            </div>
            <div className="py-3">
                <div className="d-flex align-items-center">
                    <span
                        className="rv-charge-icon-bg p-1 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                    >
                        <i class="ri-layout-top-line rv-charge-icon-color"></i>
                    </span>
                    <div className="px-2">
                        <h4 className="fs-14 mb-0 rv-text-label-color">
                            Charges
                        </h4>

                        {!isModal && (offer?.ChargeCard?.length ? (
                            <h4 class="mb-0">
                                {" "}
                                <span className="fw-semibold fs-14 text-black">
                                    {offer?.ChargeCard[0].currencySymbol}{" "}
                                    {offer?.ChargeCard[0].chargeAmount}{" "}
                                </span>
                                {offer?.ChargeCard?.length - 1 > 0 ? (
                                    <span
                                        className="rv-text-label-color fs-12 ms-2"
                                    >
                                        {" "}
                                        + {offer?.ChargeCard?.length - 1} more
                                    </span>
                                ) : (
                                    ""
                                )}
                            </h4>
                        ) : (
                            <h4 class="mb-0">
                                <span className="fw-semibold fs-14 text-black">
                                    No charges available
                                </span>
                            </h4>
                        ))}
                    </div>
                </div>
                {isModal && <div className="ms-32">
                    {offer?.ChargeCard?.length ? (offer?.ChargeCard?.map((charge, index) => (
                        <h4
                            key={index}
                            className="text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center"
                        >
                            <span className="fs-14 fw-semibold">
                                {charge?.currencySymbol} {charge?.chargeAmount}
                            </span>
                            <span className="fs-12">
                                {charge?.oneTimeorRecurring}
                            </span>
                        </h4>
                    ))) : <h4 class="mb-0">
                        <span className="fs-14 text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center">
                            No charges available
                        </span>
                    </h4>}


                </div>}



            </div>
            <div className="min-height-21">
                {(!isModal ? offer?.categories?.slice(0, 4) : offer?.categories)?.length > 0 && (
                    <div className="d-flex flex-wrap gap-2 py-2">
                        {(!isModal ? offer?.categories?.slice(0, 4) : offer?.categories)?.map((category, index) => (
                            <span key={index} className="offer-category fs-14 p-2 rounded-1">
                                {category}
                            </span>
                        ))}
                    </div>
                )}

                {!isModal &&
                    (
                        (offer?.categories?.length > 4) ||
                        (offer?.GrantCard?.length > 1) ||
                        (offer?.ChargeCard?.length > 1)
                    ) && (
                        <div className="d-flex justify-content-end">
                            <span className="text-blue cursor-pointer" onClick={() => openViewMoreModal(index, offerIndex)}>
                                <i>View more</i>
                            </span>
                        </div>
                    )}


            </div>
        </div>
    )
}

export default OfferCard